import React, { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useOrganizationId } from '@app/utils/hooks';
import { insightsOverviewPath } from '@app/constants/url';
import { InsightsTabs } from './InsightsTabs';
import InsightsPanel from './InsightsPanel';
import ExportsPanel from './ExportsPanel';

/** The Insights tab: what needs a manager's attention. */
const Overview = (): ReactElement => (
  <div className="w-full min-w-0">
    <InsightsTabs />
    <InsightsPanel />
  </div>
);

/** The Exports tab: the two documents behind the O&O claim. */
const Exports = (): ReactElement => (
  <div className="w-full min-w-0">
    <InsightsTabs />
    <ExportsPanel />
  </div>
);

/** `/insights` itself is not a tab, so it sends you to the one you land on. */
const InsightsRouter = (): ReactElement => {
  const organizationId = useOrganizationId() ?? '';

  return (
    <Routes>
      <Route path="overview" element={<Overview />} />
      <Route path="exports" element={<Exports />} />
      <Route path="*" element={<Navigate to={insightsOverviewPath(organizationId)} replace />} />
    </Routes>
  );
};

export default InsightsRouter;
